import React, { FC } from 'react';

import { Group } from '@mantine/core';

import { Component, ComponentVisibility, PublishedStatus } from 'models';

import { InAppSupportBadge } from 'components/badges/InAppSupportBadge';
import { InternalScoreBadge } from 'components/internal-score-badge/InternalScoreBadge';
import { PublishedBadge } from 'components/published-badge/PublishedBadge';
import { useCompanyProfile } from 'hooks/use-company-profile';

const ComponentOverviewHitBadges: FC<{
    component: Component;
    showIntercom?: boolean;
    isExternalLink?: boolean;
}> = ({ component, showIntercom, isExternalLink }) => {
    const { company: manufacturer } = useCompanyProfile(component.manufacturer);

    // const viewedCount = component.viewedCount || 0;

    const showUnpublished = component.manufacturer && component.visibility === ComponentVisibility.PRIVATE;

    return (
        <Group gap="xs" fz="xs" c="dimmed" mt="auto" pt="xs">
            <InternalScoreBadge item={component as any} />
            {showIntercom && manufacturer && (
                <InAppSupportBadge component={component} company={manufacturer} isExternalLink={isExternalLink} />
            )}
            {/* {viewedCount > 0 && (
                <Text inherit>
                    {viewedCount} {viewedCount === 1 ? 'view' : 'views'}
                </Text>
            )} */}
            {showUnpublished && <PublishedBadge status={PublishedStatus.DRAFT} variant="light" />}
        </Group>
    );
};

export { ComponentOverviewHitBadges };
